<template>
    <div class="calendar-container">
        <div class="row text-center mt-3">
        <div class="col-12">
            {{months[month-1]}} {{year}}
        </div>
            <div class="col"></div>
            <div class="col" v-for="(label,index) in daysLabels" :key="`label${index}`">
                {{label}}
            </div>
            <div class="col"></div>
        </div>
        <div class="row text-center mt-3">
            <div class="col"><span v-if="checkWeekStart()" @click="previousWeek" class="change-date"><</span></div>
            <div class="col" v-for="(day,index) in days" :key="`day${index}`">
                <span class="dayContainer p-1" @click="changeDay(day)" :class="`${checkDay(day) ? 'active' : ''} ${isAvailable(day) ? 'available' : 'disabled'}`">{{formatDate(day)}}</span>
            </div>
            <div class="col"><span @click="nextWeek" class="change-date">></span></div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['calendar','setDate','date'],
    data: function(){
        return {
            days: [],
            daysLabels: ['D','L','M','M','J','V','S'],
            enDays: ['sunday','monday','tuesday','wednesday','thursday','friday','saturday'],
            selectedDay: null,
            month: '',
            months: ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'],
            year: 0,
            weekStart: '',
            weekEnd: '',
            originalWeekStart: ''
        }
    },
    created(){
        if(this.date){
            this.selectedDay = this.date;
        }
        let currentDate = this.$moment();
        this.weekStart = currentDate.clone().startOf('week');
        this.originalWeekStart = this.weekStart.clone();
        this.month = this.weekStart.clone().format("M");
        this.year = this.weekStart.clone().format("YYYY");
        let selected = false;
        for (let i = 0; i <= 6; i++) {
            this.days.push(this.$moment(this.weekStart).add(i, 'days'));
            if(!selected && this.isAvailable(this.$moment(this.weekStart).add(i, 'days'))){
                selected = true;
                this.changeDay(this.$moment(this.weekStart).add(i, 'days'));
            }
        }
    },
    methods: {
        checkWeekStart(){
            return !(this.weekStart.clone().format() === this.originalWeekStart.clone().format());
        },
        nextWeek(){
            this.weekStart = this.weekStart.add(7, 'days');
            this.month = this.weekStart.clone().format("M");
            this.year = this.weekStart.clone().format("YYYY");
            this.days = [];
            let selected = false;
            for (let i = 0; i <= 6; i++) {
                this.days.push(this.$moment(this.weekStart).add(i, 'days'));
                if(!selected && this.isAvailable(this.$moment(this.weekStart).add(i, 'days'))){
                    selected = true;
                    this.changeDay(this.$moment(this.weekStart).add(i, 'days'));
                }
            }
        },
        previousWeek(){
            this.weekStart = this.weekStart.subtract(7, 'days');
            this.month = this.weekStart.clone().format("M");
            this.year = this.weekStart.clone().format("YYYY");
            this.days = [];
            let selected = false;
            for (let i = 0; i <= 6; i++) {
                this.days.push(this.$moment(this.weekStart).add(i, 'days'));
                if(!selected && this.isAvailable(this.$moment(this.weekStart).add(i, 'days'))){
                    selected = true;
                    this.changeDay(this.$moment(this.weekStart).add(i, 'days'));
                }
            }
        },
        checkDay(day){
            return this.selectedDay && day.format("DD") === this.selectedDay.format("DD");
        },
        formatDate(date){
            return this.$moment(date).format("DD");
        },
        changeDay(day){
            if(this.isAvailable(day)){                
                this.month = day.clone().format("M");
                this.year = day.clone().format("YYYY");
                this.selectedDay = day;
                this.setDate(day);
            }
        },
        isAvailable(day){
            let available = true;
            let today = this.$moment();
            day.set({"hour": 23, "minute": 59});
            if(day < today){
                available = false;
            }

            if(!this.calendar.config.working_hours[this.enDays[day.format('d')]]){
                available = false;
            }

            return available;
        }
    }
}
</script>
<style lang="scss" scoped>
.dayContainer{
    cursor: pointer;
    border-radius: 999px;
    width: auto;
}
.dayContainer.disabled{
    cursor: default;
    color: #c1bebe;
}
.dayContainer.active,
.dayContainer.available:hover{
    background-color: #f7f7f7;
    color: #f48e14;
}

.change-date:hover{
    cursor: pointer;
}
</style>